import mailIcon from '../Media/mail.png'
import linkedinIcon from '../Media/linkedinlogo.png'
import githubIcon from '../Media/githublogo.png'

const contactLinks = [
    {
        icon: mailIcon,
        iconAlt: "Email",
        href: "mailto:christinapark0117@gmail.com",
        label: "christinapark0117@gmail.com",
    },
    {
        icon: linkedinIcon,
        iconAlt: "LinkedIn",
        href: "https://www.linkedin.com/in/meet-christina-park/",
        label: "linkedin.com/in/meet-christina-park",
        external: true,
    },
    {
        icon: githubIcon,
        iconAlt: "GitHub",
        href: "https://github.com/christinapark0117",
        label: "github.com/christinapark0117",
        external: true,
    },
]

export default contactLinks
